/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { OnboardingStatusDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiOnboardingController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-onboarding-controller
   * @name Get9
   * @request GET:/api/v1/onboarding
   */
  get = (params: RequestParams = {}) =>
    this.http.request<OnboardingStatusDto, any>({
      path: `/v1/onboarding`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPath = '/v1/onboarding'
  static getMethod = 'GET'
}
